import { COLOMBO_BORDER_RADIUS, COLOMBO_BOX_SHADOW, COLOMBO_COLORS, COLOMBO_FONTS, COLOMBO_SPACING, } from '../colomboThemeConf';
export const colomboNotificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: COLOMBO_BORDER_RADIUS.default,
            boxShadow: COLOMBO_BOX_SHADOW.default,
        },
        success: {
            backgroundColor: COLOMBO_COLORS.primary.main,
        },
        info: {
            backgroundColor: COLOMBO_COLORS.brand.main,
        },
        error: {
            backgroundColor: COLOMBO_COLORS.error.main,
        },
        warning: {
            backgroundColor: COLOMBO_COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            color: COLOMBO_COLORS.font.light,
            fontSize: COLOMBO_FONTS.size.mediumBig,
            fontWeight: COLOMBO_FONTS.weight.bold,
            height: COLOMBO_FONTS.size.mediumBig,
            marginBottom: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: COLOMBO_FONTS.size.medium,
            fontWeight: COLOMBO_FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: COLOMBO_COLORS.font.light,
            marginTop: COLOMBO_SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=colomboNotificationsStyle.js.map